import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Top Section */}
        <div className="footer-top">
          <div className="footer-section">
            <h3 className="footer-title">Vietnam in Pixel</h3>
            <p className="footer-description">
              Bạn đang xem phiên bản đầu tiên của Vietnam in Pixel.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">
                ff
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">Khám phá</h4>
            <ul className="footer-links">
              <li>
                <a href="/trang-chu">Trang chủ</a>
              </li>
              <li>
                <a href="/thu-vien">Thư viện</a>
              </li>
              <li>
                <a href="/quy-dinh">Quy định</a>
              </li>
              <li>
                <a href="/huong-dan">Hướng dẫn</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 Tất cả quyền được bảo lưu. All rights reserved.
            </p>

            <div className="footer-bottom-links">
              <a href="#">Chính sách bảo mật</a>
              <a href="#">Cookie Policy</a>
            </div>
          </div>
        </div>

        
      </div>
    </footer>
  );
};

export default Footer;
